/**
 * 接待员 接口的统一出口
 */
import axios from '../http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/smartorder/'

const smartorder = {
  // 列表
  list(params) {
    return axios.get(api + 'list', { params: params })
  },
  //次卡订单
  timecardorder(params) {
    return axios.get(api + 'timecardorder', { params: params })
  },
  // 个人订单信息
  userdetail(params) {
    return axios.get(api + 'userdetail', { params: params })
  },
  //团队订单信息
  orderdetail(params) {
    return axios.get(api + 'orderdetail', { params: params })
  },
  orderimport(params) {
    return axios.post(api + 'orderimport', qs.stringify(params))
  },
  //修改团队订单
  orderedit(params) {
    return axios.post(api + 'orderedit', qs.stringify(params))
  },
  //  导出团队订单
  exportteamorder(params) {
    return axios.post(api + 'exportteamorder', qs.stringify(params))
  },
  // 导出散客订单
  exportuserorder(params) {
    return axios.post(api + 'exportuserorder', qs.stringify(params))
  },
  //上传发票
  shangchuaninvoice(params) {
    return axios.post(api + 'shangchuaninvoice', qs.stringify(params))
  },
}

// 导出接口
export default smartorder
